import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RefundsService } from '../../../services/refund.service';
import { Refund } from '../../../models/Refund.model';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { ErrorHandlerProvider } from '../../../shared/providers/errorHandler.provider';
import { isBlockPeriodInvalid } from '../../../shared/helpers/validate-block-period';
import { AccountingPeriodBlockService } from '../../../services/accountingBlock.service';
import { AccountingPeriodBlock } from '../../../models/AccountingPeriodBlock.model';
import { AccountingType } from '../../../shared/enums/AccountingBlockType';
import { FileManagerService } from '../../../services/file-manager.service'

@Component({
  selector: 'app-refund-detail',
  templateUrl: './refund-detail.component.html',
  styleUrls: ['./refund-detail.component.scss']
})
export class RefundDetailComponent implements OnInit {

  loading;
  _id: string;
  status: number = 1;
  refund: Refund = new Refund();
  associatedBillingLetterAux: Boolean = false;
  sapDocNum: String = '';
  accountingBlock = new AccountingPeriodBlock();
  monthList;
  descriptionsDict = {};

  constructor(private refundsService: RefundsService,
              private router: Router,
              private route: ActivatedRoute,
              private commonHelper: CommonHelper,
              private errorHandler: ErrorHandlerProvider,
              private fileManager: FileManagerService,
              private toastr: ToastsManager,
              private accountingBlockService: AccountingPeriodBlockService
              ) { }

  async ngOnInit() {
    this.loading = true;
    this.accountingBlock = (await this.accountingBlockService.getAllBlockedPeriods())
        .find((ac: AccountingPeriodBlock) => ac.type === AccountingType.Refund);
    this.monthList = this.commonHelper.listAllMonths();
    this._id = this.route.snapshot.params['id'];
    this.refund = await this.refundsService.getRefund(this._id);
    if(this.refund.associatedBillingLetter) this.associatedBillingLetterAux = true;
    this.loading = false;

    for (let expense of this.refund.expenses) {
        if (expense.description) {
            this.descriptionsDict[expense._id] = {
                active: false,
                excerpt:  this.cropExpenseDescription(expense.description),
                fullDescription: expense.description
            };
        }
    }
  }

  OnCancel(){
    this.router.navigate(['/refunds']);
  }

  valuePaidInvalid(): boolean {
    if(this.refund.valuePaidCustomer == undefined ||
       isNaN(this.refund.valuePaidCustomer) ||
       this.refund.valuePaidCustomer == 0 ||
       this.refund.valuePaidCustomer > this.refund.value)
      return true;
    return false;
  }

  async saveRefund() {
    try{
      this.loading = true;
      const pendingPaymentStatus = 2;
      if (this.refund.statusFinancial == pendingPaymentStatus) {
        const refundDate = new Date(this.refund.created);
        const refundlMonth = refundDate.getMonth() + 1;
        const refundYear = refundDate.getFullYear();
        const isInvalid = isBlockPeriodInvalid({
          competence: refundlMonth,
          competenceYear: refundYear
        }, this.accountingBlock);
        if (isInvalid) {
          this.loading = false;
          return this.toastr.warning(`A competência
          ${this.monthList[refundDate.getMonth()].name.toLowerCase()}/${refundYear} deste reembolso
              está dentro do intervalo de bloqueio. Não será possível editar`, 'Bloqueio Contábil', {
          toastLife:8000,
          showCloseButton: true
          });
        };
      };
      let res = await this.refundsService.update(this.refund);
      if(res._id){
        this.toastr.success('Reembolso atualizado com sucesso!');
      } else {
        this.errorHandler.interceptError(res, 'Remembolso');
      }
      this.loading = false;
      this.router.navigate(['/refunds']);
    }catch(err){
      this.loading = false;
      this.router.navigate(['/refunds']);
      this.errorHandler.interceptError(err, 'Remembolso');
    }
  }

  async getSapDocNum() {
    try {
        this.loading = true;
        let respSAP = await this.refundsService.getSapDocNumByRefund(this.refund.sapDocEntry);
        if(respSAP && respSAP.DocNum)
           this.sapDocNum = respSAP.DocNum;
        else
            this.errorHandler.interceptError(respSAP, 'Reembolso');
        this.loading = false;
    } catch(err) {
        console.log(err);
        this.loading = false;
        this.errorHandler.interceptError(err, 'Reembolso');
    }
  }

  openAttachment(expense: any): void {
    if (!expense.attachment) return;
    this.fileManager.getAccessUrl(expense.attachment).then((res) => {
        window.open(res.accessUrl, '_blank')
    })
  }

  checkDescriptionLength(description: string | undefined): boolean {
    return description && description.length > 50;
  }

  expandDescription(expense): void {
    if (!this.checkDescriptionLength(expense.description))
        return;
    this.descriptionsDict[expense._id].active = !this.descriptionsDict[expense._id].active;
  }

  cropExpenseDescription(description: string): string {
    if (!description || description == '') return '-'

    if (String(description).length > 50)
        return `${String(description).substring(0, 50)}...`

    return description
  }
}



// WEBPACK FOOTER //
// ./src/app/views/refunds-report/refund-detail/refund-detail.component.ts